<template>
  <div id="app">
    <cover :flag="flag" @change="flagFn($event)"></cover>
    <Header :bgUrl="$route.meta.bgUrl"></Header>
    <router-view/>
    <Footer class="hidden-xs"></Footer>
    <Footer2 class="visible-xs"></Footer2>
    <GoTop class="hidden-xs" @change="coverChange($event)"></GoTop>
    <GoTop2 class="visible-xs" @change="coverChange($event)"></GoTop2>
  </div>
</template>

<script>
import Footer2 from './components/Footer2.vue'
export default {
  name: 'App',
  components: {Footer2},
  data() {
    return {
      flag: false
    };
  },
  methods: {
    coverChange(value) {
      this.flag = value
    },
    flagFn(value) {
      this.flag = value
    }
  },
  created() {
    console.log(this.$route.meta.bgUrl)
  }
}
</script>

<style>
* {
  -webkit-text-size-adjust: 100% !important;
}
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue